import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { EsnIconName } from '../../../shared/icons';
import { IconComponent } from '../../atoms/icon/icon.component';

/**
 * One entry of the navigation rail: glyph plus label, with a distinct look for the page the
 * user is on. Wrap it in your own link (e.g. `<a routerLink routerLinkActive>`) and bind `active`.
 */
@Component({
  selector: 'esn-nav-item',
  imports: [IconComponent],
  templateUrl: './nav-item.component.html',
  styleUrl: './nav-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent {
  readonly icon = input<EsnIconName | null>(null);
  readonly active = input(false);

  /**
   * `sm` is the 14/21 label of the rail's footer entries (Help Center, Take the tour).
   */
  readonly size = input<'md' | 'sm'>('md');
}
